import { Box, Button, Stack } from '@mui/material';

const Navbar = () => (
  <Box
    component="nav"
    sx={{
      bgcolor: 'background.blue',
      px: 2.5, // 20px (5 * 4px)
      py: 1,   // 8px (2 * 4px)
    }}
  >
    <Stack
      direction="row"
      spacing={1}
      sx={{
        listStyle: 'none',
      }}
    >
      <Button
        component="a"
        href="/drag"
        sx={{
          display: 'flex',
          alignItems: 'center',
          color: 'text.white',
          fontSize: (theme: any) => theme.typography.fontSizes.subheading,
          px: 1.5, // 12px (3 * 4px)
          py: 1,   // 8px (2 * 4px)
          borderRadius: 1,
          bgcolor: 'background.warning',
          textTransform: 'none',
          textDecoration: 'none',
          '&:hover': {
            bgcolor: 'background.blue',
          },
        }}
      >
        <Box component="span" sx={{ mr: 1 }}>
            ❌
        </Box>
          Atmesti
      </Button>

      <Button
        component="a"
        href="#"
        sx={{
          display: 'flex',
          alignItems: 'center',
          color: 'text.white',
          fontSize: (theme: any) => theme.typography.fontSizes.subheading,
          px: 1.5,
          py: 1,
          borderRadius: 1,
          bgcolor: 'background.green',
          textTransform: 'none',
          textDecoration: 'none',
          transition: 'background-color 0.5s ease',
          '&:hover': {
            bgcolor: 'background.green',
          },
        }}
      >
        <Box component="span" sx={{ mr: 1 }}>
            💾
        </Box>
          Išsaugoti
      </Button>

      <Button
        component="a"
        href="#"
        sx={{
          display: 'flex',
          alignItems: 'center',
          color: 'text.white',
          fontSize: (theme: any) => theme.typography.fontSizes.subheading,
          px: 1.5,
          py: 1,
          borderRadius: 1,
          bgcolor: 'background.darkGrey',
          textTransform: 'none',
          textDecoration: 'none',
          '&:hover': {
            bgcolor: 'background.blue',
          },
        }}
      >
        <Box component="span" sx={{ mr: 1 }}>
            ➕
        </Box>
          Naujas
      </Button>
    </Stack>
  </Box>
);

export default Navbar;
